import Reports from '../../pages/Reports';
import ReportsUsers from '../../pages/Reports/Users';

import { uuid } from '../../utils/helper';

export default [
  {
    name: 'Users',
    link: '/reports/users',
    secondaryLinks: [],
    id: uuid(),
    component: ReportsUsers,
    react: true,
  },
  {
    name: 'Reports',
    link: '/reports',
    secondaryLinks: [
      '/reports/payments',
      '/reports/payments/table',
      '/reports/orders',
      '/reports/tickets',
      '/reports/profits',
      '/reports/services',
    ],
    id: uuid(),
    component: Reports,
    react: true,
  },
];
